import { render, staticRenderFns } from "./homeSlider.vue?vue&type=template&id=6aaea706&scoped=true"
import script from "./homeSlider.vue?vue&type=script&lang=js"
export * from "./homeSlider.vue?vue&type=script&lang=js"
import style0 from "./homeSlider.vue?vue&type=style&index=0&id=6aaea706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaea706",
  null
  
)

export default component.exports